var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      ref: "multipleTable",
      staticStyle: { width: "100%" },
      attrs: { data: _vm.tableData, "tooltip-effect": "dark" },
      on: { "selection-change": _vm.handleSelectionChange },
    },
    [
      _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
      _c("el-table-column", {
        attrs: { label: "库存类型/生成人", width: "120" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [_vm._v(_vm._s(scope.row.date))]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { prop: "name", label: "产品类型", width: "120" },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "address",
          label: "资源方",
          "show-overflow-tooltip": "",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "address",
          label: "车存ID",
          "show-overflow-tooltip": "",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "address",
          label: "产品名称/产品ID",
          "show-overflow-tooltip": "",
        },
      }),
      _c("el-table-column", {
        attrs: { prop: "address", label: "描述", "show-overflow-tooltip": "" },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "address",
          label: "库存价格",
          "show-overflow-tooltip": "",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "address",
          label: "C端价格",
          "show-overflow-tooltip": "",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "address",
          label: "B端价格",
          "show-overflow-tooltip": "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }